import React from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import toggles from 'feature-toggles'

import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"

import validationService from 'data/validate'

type Route = {
  name: string
  link: string
}
type AssetManagementState = {
  tabs: Route[]
}

class AssetManagement extends React.Component<RouteComponentProps, AssetManagementState> {
  constructor(props) {
    super(props)
    this.state = {
      tabs: []
    }
  }

  async componentWillMount() {
    await toggles.get()
    const explorerTab = toggles.displayAssetManagementV1() ? [{name: "Asset Explorer", link: "/n/asset-management/explorer"}] : []
    const comparisonTab = toggles.displayComparisons() ? [{name: "Comparison", link: "/n/asset-management/comparison"}] : []
    const tabs = [
      ...explorerTab,
      {name: "Asset List", link: "/n/asset-management/asset-list"},
      {name: "Attributes", link: "/n/asset-management/attributes"},
      {name: "Portfolios", link: "/n/asset-management/portfolios"},
      {name: "Chart", link: "/n/asset-management/chart"},
      ...comparisonTab,
      {name: "Reports", link: "/n/asset-management/reports"},
      {name: "Audit Log", link: "/n/asset-management/audit-log"},
    ]
    this.setState({tabs})
    validationService.addFilter(this.validationFilter)
    validationService.fetchAll('asset')
    validationService.fetchAll('assetattribute')
    validationService.fetchAll('attribute')
    validationService.fetchAll('chart')
    validationService.fetchAll('cashflowmap')
    validationService.fetchAll('detailaccount')
    validationService.fetchAll('portfolio')
    validationService.fetchAll('summaryaccount')
  }

  componentWillUnmount() {
    validationService.removeFilter(this.validationFilter)
  }

  validationFilter(errors) {
    return {
      ...errors,
      errordetail: _.pick(errors.errordetail, 'asset', 'assetattribute', 'attribute', 'chart', 'portfolio', 'summaryaccount', 'detailaccount', 'cashflowmap'),
      calcDetail: undefined
    }
  }

  render() {
    return (
      <Container_s>
        {this.state.tabs.length > 0 && <Subnav section="ASSET MANAGEMENT" tabs={this.state.tabs}/>}
        <Content_s>
          {this.props.children}
        </Content_s>
      </Container_s>
    )
  }
}

export default AssetManagement
